var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',[_c('div',{},[_vm._v(" "+_vm._s(_vm.getDate(_vm.value))+" ")]),_c('div',{staticClass:"body-xs-semibold neutral-600--text"},[_vm._v(" "+_vm._s('в\u00A0' + _vm.getTime(_vm.value))+" ")])]):_c('div',[_vm._v(" - ")])}
var staticRenderFns = []

export { render, staticRenderFns }